var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1465 21V13H7.14648V21M7.14648 3V8H15.1465M19.1465 21H5.14648C4.61605 21 4.10734 20.7893 3.73227 20.4142C3.3572 20.0391 3.14648 19.5304 3.14648 19V5C3.14648 4.46957 3.3572 3.96086 3.73227 3.58579C4.10734 3.21071 4.61605 3 5.14648 3H16.1465L21.1465 8V19C21.1465 19.5304 20.9358 20.0391 20.5607 20.4142C20.1856 20.7893 19.6769 21 19.1465 21Z",
    stroke: "#4C60E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBlue);
export default __webpack_public_path__ + "static/media/SaveBlue.ad864b94722fba6cefed07667f7e36c3.svg";
export { ForwardRef as ReactComponent };